import React, { useState, useEffect } from 'react';
import { Container, Header, Link, ColumnLayout } from '@amzn/awsui-components-react-v3';

export const AsinAnalysis = (props) => {
  return (
    <Container
      className="custom-dashboard-container"
      header={
        <Header variant="h2" description="Analyze target ASINs">
          ASINs Analysis
        </Header>
      }
    ></Container>
  );
};


// WEBPACK FOOTER //
// ./src/components/spotcp/asin-analysis.jsx